import { IMaterial, IdefaultSearchParams } from "@/models/types";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios, { AxiosResponse } from "axios";
import { SERVER_API_URL } from "src/config/constants";

const INITIAL_STATE = {
  loading: false,
  errorMessage: null as unknown as string,
  fetchSuccess: false,
  fetchFailure: false,
  search: null as unknown as IMaterial[],
  count: null as unknown as number,
  refresh: 0,
};

export type MaterialsSearchState = Readonly<typeof INITIAL_STATE>;

export const getMaterials = createAsyncThunk(
  "materials/search",
  async (params: IdefaultSearchParams, { rejectWithValue }) => {
    try {
      const response: AxiosResponse<IMaterial[]> = await axios.post(
        `${SERVER_API_URL}/api/materials/search`,
        params
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const materialsSearchSlice = createSlice({
  name: "post",
  initialState: INITIAL_STATE,
  reducers: {
    refreshMaterialsSearch(state) {
      return {
        ...state,
        refresh: state.refresh + 1,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMaterials.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(getMaterials.fulfilled, (state, { payload }) => {
        return {
          ...state,
          loading: false,
          fetchSuccess: true,
          search: payload,
        };
      })
      .addCase(getMaterials.rejected, (state) => {
        return {
          ...state,
          loading: false,
          fetchFailure: true,
        };
      });
  },
});

const { actions } = materialsSearchSlice;
export const { refreshMaterialsSearch } = actions;
export default materialsSearchSlice.reducer;
